import { useQuery } from '@apollo/client';
import { Products } from '@components/Product';
import { styled } from '@mui/system';
import Link from 'next/link';
import {
  getCategoryOnlyQueryResponse,
  getCategoryOnlyQueryParams,
  getCategoryOnly,
} from '@queries/category';
import { useWindowSize } from '@hooks/useWindowSize';
import { getRoute } from '@utils';
import { useSegment } from '@hooks/useSegment';

interface CategoryProductsProps {
  slug: string;
  productLocation?: string;
  categoryLocation?: string;
}

const TextLink = styled('a')(() => ({
  color: '#0A7ABE',
  textDecoration: 'none',
}));

export function CategoryProducts(props: CategoryProductsProps) {
  const { width } = useWindowSize();
  const { slug, productLocation, categoryLocation } = props;
  const { track } = useSegment();
  const { data } = useQuery<
    getCategoryOnlyQueryResponse,
    getCategoryOnlyQueryParams
  >(getCategoryOnly('categoryBestSelling'), {
    variables: {
      params: {
        slug: slug,
      },
    },
    fetchPolicy: 'cache-and-network',
  });
  const categoryName = data?.category?.name;
  const categoryTitle =
    width < 600 ? categoryName : `Lo más visto en ${categoryName}`;

  return (
    <>
      {data?.category?.products?.length > 0 && (
        <Products.Carousel
          data={data?.category?.products?.map((product) => ({
            product,
          }))}
          totalCount={data?.category?.products.length}
          loading={false}
          title={categoryTitle}
          action={
            <Link
              {...getRoute('category', {
                categorySlug: slug,
                page: '1',
              }).toLink()}
              passHref
            >
              <TextLink
                onClick={() => {
                  void track('category', {
                    category: data?.category?.name,
                    location: categoryLocation,
                  });
                }}
              >
                Ver todo
              </TextLink>
            </Link>
          }
          location={productLocation}
        />
      )}
    </>
  );
}
